/** Returns the current locale in the form "xx-YY" from the URL */
export const getLocaleFromUrl = () => getPathParts()[0];

/** Returns an array containing all parts of the current pathname */
export const getPathParts = () => {
  const pathParts = location.pathname.split("/");
  /*
      Find the part of the URL that has "/dashboard/" and return the URL parts from the previous segment.
      This makes it so that e.g.:
          /6807580/properties/en-us/dashboard/products/9MT967WN0JLW/gamingproperties/
      and
          /en-us/dashboard/products/9MT967WN0JLW/gamingproperties/
      will both return:
          ['en-us', 'dashboard', 'products', '9MT967WN0JLW', 'gamingproperties', '']
  */
  const dashboardIndex = pathParts.findIndex(part => part.toLowerCase() === "dashboard");
  return pathParts.slice(dashboardIndex - 1);
};
